import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ConsultaSolicitacoesService {

  API

  // public URLDepartamentos: string = 'http://192.168.25.6:8086/api/Departamento';
  // public URLConsultaSolicitacao: string = 'http://192.168.25.6:8086/api/ConsultaSolicitacao';
  // public URLAlteraStatusResposanvel: string = 'http://192.168.25.6:8086/api/ConsultaSolicitacao/alterastatuseresponsavel'
  
  constructor(private http: HttpClient) {
    environment.emitAPI.subscribe(api => {
      this.API = api
    })
  }

  public getListaDepartamento(): Promise<any> {
    return this.http.get(`${this.API}Departamento`).toPromise()
  }

  public getResultadoFiltro(corpo: object): Promise<any> {
    return this.http.post(`${this.API}ConsultaSolicitacao`, corpo).toPromise()
  }

  public setAtribuicaoTarefa(corpo: object): Promise<any> {
    return this.http.post(`${this.API}ConsultaSolicitacao`, corpo).toPromise()
  }
  
  public getColaboradores(id?): Promise<any> {

    if(id){
      return this.http.get(`${this.API}ConsultaSolicitacao/GetEquipe/${id}`).toPromise();
    } else {
      return this.http.get(`${this.API}ConsultaSolicitacao/GetEquipe/0`).toPromise();
    }

  }

  public getSolicitacoes(id: number): Promise<any> {
    return this.http.get(`${this.API}ConsultaSolicitacao/${id}`).toPromise();
  }
  
  public setAlteraStatusResposanvel(corpo: object): Promise<any> {
    return this.http.post(`${this.API}ConsultaSolicitacao/alterastatuseresponsavel`, corpo).toPromise()
  }
  
  public getSolicitacoesAtribuidas(){
    return this.http.get(`${this.API}ListagemSolicitacoes/GetSolicitacoesAtribuida`)
  }
  
  public getSolicitacoesDevolvidas(){
    return this.http.get(`${this.API}ListagemSolicitacoes/GetSolicitacoesDevolvida`)
  }

  public getSolicitacoesAberta(){
    return this.http.get(`${this.API}ListagemSolicitacoes/GetSolicitacoesAberta`)
  }

  public getHistoricoAnotacao(corpo: object){
    return this.http.get(`${this.API}RelatorioHistoricoAnotacao`, corpo)
  }

  public getSolicitacoesTabela(corpo: object){
    return this.http.post(`${this.API}ConsultaSolicitacao/GetConsultaAtendimentoTabela`, corpo)
  }
}
